// PCM → WAV encoding (16 kHz mono s16le). Pure; unit-tested.
// Why WAV and not MediaRecorder/webm: DESIGN.md D5.

export const SAMPLE_RATE = 16_000;

/** Convert float samples [-1,1] to a complete WAV file. */
export function encodeWav(samples: Float32Array): Uint8Array {
  const dataLen = samples.length * 2;
  const buf = new ArrayBuffer(44 + dataLen);
  const view = new DataView(buf);
  const writeStr = (off: number, s: string) => {
    for (let i = 0; i < s.length; i++) view.setUint8(off + i, s.charCodeAt(i));
  };
  writeStr(0, "RIFF");
  view.setUint32(4, 36 + dataLen, true);
  writeStr(8, "WAVE");
  writeStr(12, "fmt ");
  view.setUint32(16, 16, true); // fmt chunk size
  view.setUint16(20, 1, true); // PCM
  view.setUint16(22, 1, true); // mono
  view.setUint32(24, SAMPLE_RATE, true);
  view.setUint32(28, SAMPLE_RATE * 2, true); // byte rate
  view.setUint16(32, 2, true); // block align
  view.setUint16(34, 16, true); // bits per sample
  writeStr(36, "data");
  view.setUint32(40, dataLen, true);
  let off = 44;
  for (let i = 0; i < samples.length; i++) {
    // Clamp, scale, and round to s16le.
    const s = Math.max(-1, Math.min(1, samples[i] ?? 0));
    view.setInt16(off, Math.round(s < 0 ? s * 0x8000 : s * 0x7fff), true);
    off += 2;
  }
  return new Uint8Array(buf);
}

export function wavBlob(samples: Float32Array): Blob {
  const bytes = encodeWav(samples);
  return new Blob([bytes.buffer as ArrayBuffer], { type: "audio/wav" });
}
